import React, { useState } from 'react';
import Icon from '@/components/AppIcon';
import Button from '@/components/ui/Button';
import Input from '@/components/ui/Input';
import Select from '@/components/ui/Select';
import { ArrowLeft, Calendar, Clock, Building2, MapPin, DollarSign, Users, TrendingUp, FileText, Briefcase, Target, MessageSquare, Brain, CheckCircle, AlertCircle, ExternalLink, Plus, X, Loader } from 'lucide-react';

const MockScheduleModal = ({ 
setShowMockScheduleModal,
interview,
handleScheduleMockInterview
 }) => {


return (
<div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50 backdrop-blur-md">
<div className="bg-white rounded-lg max-w-md w-full p-6">
<div className="flex items-center justify-between mb-4">
<h2 className="text-lg font-bold text-gray-900">Schedule AI Mock Interview</h2>
<button
onClick={() => setShowMockScheduleModal(false)}
className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
>
<X className="w-5 h-5" />
</button>
</div>

<p className="text-gray-600 text-sm mb-6">
Practice for your upcoming interview with <span className="font-bold text-gray-900">{interview.company}</span> using our AI-powered mock interview system. Get personalized feedback and improve your performance.
</p>

<div className="space-y-4 mb-6">
<div className="flex items-start gap-3 p-3 bg-purple-50 rounded-lg">
<Brain className="w-5 h-5 text-purple-600 mt-0.5" />
<div>
<h4 className="font-medium text-gray-900">AI-Powered Practice</h4>
<p className="text-sm text-gray-600">Realistic interview simulation with instant feedback</p>
</div>
</div>
<div className="flex items-start gap-3 p-3 bg-blue-50 rounded-lg">
<Target className="w-5 h-5 text-blue-600 mt-0.5" />
<div>
<h4 className="font-medium text-gray-900">Role-Specific Questions</h4>
<p className="text-sm text-gray-600">Questions tailored to {interview.jobTitle}</p>
</div>
</div>
<div className="flex items-start gap-3 p-3 bg-green-50 rounded-lg">
<FileText className="w-5 h-5 text-green-600 mt-0.5" />
<div>
<h4 className="font-medium text-gray-900">Detailed Performance Report</h4>
<p className="text-sm text-gray-600">Get insights on your strengths and areas to improve</p>
</div>
</div>
</div>

<div className="flex gap-3">
<button
onClick={() => setShowMockScheduleModal(false)}
className="flex-1 px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
>
Cancel
</button>
<button
onClick={handleScheduleMockInterview}
className="flex-1 px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors"
>
Continue
</button>
</div>
</div>
</div>
);
};

export default MockScheduleModal;